import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div style={{ background: 'var(--bg-primary)', minHeight: '100vh', paddingTop: '80px' }}>
      {/* Header Spacing */}
      <div style={{ height: '80px' }} />

      <div
        style={{
          maxWidth: '900px',
          margin: '0 auto',
          padding: '60px 7.6923%',
        }}
      >
        {/* Back Button */}
        <button
          onClick={() => navigate('/')}
          style={{
            background: 'transparent',
            border: '1px solid var(--border-subtle)',
            color: 'var(--text-primary)',
            padding: '12px 24px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            cursor: 'pointer',
            marginBottom: '40px',
            fontSize: '16px',
            transition: 'all 0.3s ease',
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'var(--brand-hover)';
            e.target.style.borderColor = 'var(--brand-primary)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'transparent';
            e.target.style.borderColor = 'var(--border-subtle)';
          }}
        >
          <ArrowLeft size={20} />
          Kembali ke Beranda
        </button>

        {/* Title */}
        <h1
          style={{
            fontSize: '48px',
            fontWeight: 600,
            color: 'var(--text-primary)',
            marginBottom: '16px',
          }}
        >
          Syarat & Ketentuan
        </h1>
        <p
          style={{
            fontSize: '18px',
            color: 'var(--text-muted)',
            marginBottom: '40px',
          }}
        >
          Terakhir diperbarui: {new Date().toLocaleDateString('id-ID', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>

        {/* Content */}
        <div style={{ color: 'var(--text-secondary)', lineHeight: 1.8, fontSize: '16px' }}>
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              1. Penerimaan Syarat
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Dengan mengunduh, menginstall, atau menggunakan aplikasi BAiBOT inDriver ("Aplikasi"), Anda menyetujui untuk terikat oleh Syarat dan Ketentuan ini. Jika Anda tidak setuju dengan syarat ini, mohon untuk tidak menggunakan Aplikasi.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              2. Deskripsi Layanan
            </h2>
            <p style={{ marginBottom: '16px' }}>
              BAiBOT inDriver adalah aplikasi otomasi pihak ketiga yang dirancang untuk membantu driver inDriver dalam mengelola pesanan dengan fitur-fitur seperti:
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li>Auto Accept & Auto Skip pesanan</li>
              <li>Filter harga dan area</li>
              <li>Auto Up Price</li>
              <li>Filter jarak dan rating</li>
              <li>Leaderboard penghasilan</li>
              <li>Anti-Hack & Device ID Protection</li>
            </ul>
            <p style={{ marginBottom: '16px' }}>
              Aplikasi ini menggunakan Android Accessibility Service untuk berinteraksi dengan aplikasi inDriver.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              3. Persyaratan Android 15+
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Untuk pengguna Android 15 ke atas, Anda diwajibkan menginstall aplikasi pendukung berikut sebelum menggunakan BAiBOT inDriver:
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li>BAINSTALLER - Aplikasi installer khusus untuk Android 15+</li>
              <li>Shizuku - Framework untuk izin sistem Android 15+</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              4. Tanggung Jawab Pengguna
            </h2>
            <p style={{ marginBottom: '16px' }}>Dengan menggunakan Aplikasi ini, Anda setuju untuk:</p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li>Menggunakan Aplikasi sesuai dengan hukum dan peraturan yang berlaku</li>
              <li>Tidak menggunakan Aplikasi untuk tujuan ilegal atau melanggar ketentuan layanan inDriver</li>
              <li>Bertanggung jawab penuh atas akun inDriver Anda</li>
              <li>Memahami risiko penggunaan aplikasi otomasi pihak ketiga</li>
              <li>Tidak menyalahgunakan fitur-fitur Aplikasi</li>
              <li>Menjaga kerahasiaan Device ID dan informasi akses Anda</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              5. Disclaimer dan Pembatasan Tanggung Jawab
            </h2>
            <p style={{ marginBottom: '16px', fontWeight: 600, color: 'var(--brand-primary)' }}>
              PENTING: BAiBOT inDriver adalah aplikasi pihak ketiga yang tidak berafiliasi dengan inDriver.
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li>Aplikasi disediakan "sebagaimana adanya" tanpa jaminan apapun</li>
              <li>Kami tidak bertanggung jawab atas pemblokiran atau penangguhan akun inDriver Anda</li>
              <li>Kami tidak bertanggung jawab atas kerugian finansial atau kehilangan penghasilan</li>
              <li>Risiko penggunaan sepenuhnya ditanggung oleh pengguna</li>
              <li>Kami tidak menjamin Aplikasi akan selalu berfungsi tanpa error atau gangguan</li>
              <li>Kami berhak mengubah, menangguhkan, atau menghentikan layanan kapan saja</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              6. Izin Aplikasi
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Aplikasi memerlukan izin Accessibility Service untuk dapat berfungsi. Izin ini digunakan untuk:
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li>Membaca informasi pesanan dari aplikasi inDriver</li>
              <li>Melakukan tindakan otomatis (accept/skip) sesuai preferensi Anda</li>
              <li>Mengatur filter dan pengaturan otomasi</li>
            </ul>
            <p style={{ marginBottom: '16px' }}>
              Kami tidak menggunakan izin ini untuk tujuan lain di luar fungsi otomasi pesanan inDriver.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              7. Pembayaran dan Langganan
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Aplikasi BAiBOT inDriver menggunakan sistem akses berbayar dengan pilihan paket:
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li>1 Hari: Rp 7.000</li>
              <li>30 Hari: Rp 45.000</li>
              <li>90 Hari: Rp 95.000</li>
            </ul>
            <p style={{ marginBottom: '16px' }}>
              Pembayaran dikelola oleh sistem admin. Akses diberikan berdasarkan Device ID. Tidak ada pengembalian dana setelah pembayaran dikonfirmasi.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              8. Keamanan dan Anti-Hack
            </h2>
            <p style={{ marginBottom: '16px' }}>
              BAiBOT inDriver dilengkapi dengan sistem Anti-Hack dan Device ID Protection untuk melindungi akses Anda. Setiap akun terikat dengan Device ID tertentu dan tidak dapat digunakan di perangkat lain tanpa otorisasi.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              9. Pembaruan dan Perubahan
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Kami berhak untuk memperbarui Aplikasi dan mengubah Syarat & Ketentuan ini kapan saja. Perubahan akan berlaku segera setelah dipublikasikan. Penggunaan berkelanjutan Aplikasi setelah perubahan dianggap sebagai penerimaan terhadap syarat yang diperbarui.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              10. Pemutusan Akses
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Kami berhak untuk menangguhkan atau menghentikan akses Anda ke Aplikasi jika:
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li>Anda melanggar Syarat & Ketentuan ini</li>
              <li>Anda menggunakan Aplikasi untuk tujuan ilegal</li>
              <li>Kami menemukan aktivitas mencurigakan atau penyalahgunaan</li>
              <li>Atas permintaan otoritas hukum yang berwenang</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              11. Kontak
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Jika Anda memiliki pertanyaan tentang Syarat & Ketentuan ini, silakan hubungi kami:
            </p>
            <ul style={{ marginLeft: '24px', listStyle: 'none' }}>
              <li style={{ marginBottom: '8px' }}>WhatsApp: 085175369335</li>
              <li style={{ marginBottom: '8px' }}>Telegram: https://t.me/realbai</li>
              <li>WhatsApp Group: https://chat.whatsapp.com/Blx1Cc3PeBc4oJSdg1opyT</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '28px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '16px' }}>
              12. Hukum yang Berlaku
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Syarat & Ketentuan ini diatur oleh dan ditafsirkan sesuai dengan hukum Republik Indonesia. Setiap perselisihan yang timbul akan diselesaikan melalui musyawarah atau di pengadilan yang berwenang di Indonesia.
            </p>
          </section>

          <div
            style={{
              background: 'rgba(0, 255, 209, 0.05)',
              border: '1px solid rgba(0, 255, 209, 0.2)',
              padding: '24px',
              marginTop: '60px',
            }}
          >
            <p style={{ fontSize: '16px', color: 'var(--text-secondary)', margin: 0, lineHeight: 1.6 }}>
              <strong style={{ color: 'var(--brand-primary)' }}>Perhatian:</strong> Dengan menggunakan BAiBOT inDriver, Anda mengakui bahwa Anda telah membaca, memahami, dan menyetujui semua Syarat & Ketentuan di atas. Jika Anda tidak setuju, mohon untuk segera berhenti menggunakan Aplikasi.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
